import UserPerGroup from '../userPerGroup';
import './style.scss';

function UserItem({ beneficiaries }) {
  return (
    <div className='head-main-container'>
      <table className='beneficiaries-table'>
        <thead>
          <tr>
            <th>Documento de identidad</th>
            <th>Nombre del beneficiario</th>
          </tr>
        </thead>
        <tbody>
          {beneficiaries.length > 0 &&
            beneficiaries.map((user) => (
              <UserPerGroup
                key={user?.id || `${user?.document || user?.dni}-${user?.full_name || user?.name}`}
                user={user}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default UserItem;
